var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "black",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2828 15.0001L21.7342 9.54851C22.089 9.1939 22.089 8.62056 21.7342 8.26595C21.3796 7.91135 20.8063 7.91135 20.4517 8.26595L15.0001 13.7176L9.54863 8.26595C9.19386 7.91135 8.62068 7.91135 8.26608 8.26595C7.91131 8.62056 7.91131 9.1939 8.26608 9.54851L13.7175 15.0001L8.26608 20.4517C7.91131 20.8063 7.91131 21.3797 8.26608 21.7343C8.4428 21.9111 8.67516 22 8.90735 22C9.13955 22 9.37174 21.9111 9.54863 21.7343L15.0001 16.2827L20.4517 21.7343C20.6285 21.9111 20.8607 22 21.0929 22C21.3251 22 21.5573 21.9111 21.7342 21.7343C22.089 21.3797 22.089 20.8063 21.7342 20.4517L16.2828 15.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconWhite);
export default __webpack_public_path__ + "static/media/closeIconWhite.f4641bf7.svg";
export { ForwardRef as ReactComponent };